<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="content">
      <i class="el-icon-check"></i>
      <h1>您已成功提交</h1>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.el-icon-check {
  background-color: #87a86c;
  color: #fff;
  font-size: 50px;
  border-radius: 50%;
  // margin-right: 20px;
}
h1 {
  display: inline-block;
}
h1 {
  position: absolute;
  bottom: 50%;
  margin-bottom: -50px;
  left: 50%;
  margin-left: -50px;
}
i {
  position: absolute;
  bottom: 50%;
  margin-bottom: -50px;
  left: 45%;
  margin-left: -50px;
}
</style>
